import { retrieveSpecialistAppointments } from "../../../../../redux/admin-slices/specialist.slice";
import TablePagination from "../../../../../components/common/PaginationSkell";
import EntriesSelect from "../../../../../components/ui/EntriesSelect";
import Messages from "../../../../../components/common/messages/chat";
import useChatInitiater from "../../../../../hooks/useChatInitiater";
import TableSkell from "../../../../../components/common/TableSkell";
import SelectInput from "../../../../../components/ui/SelectInput";
import InputFieldA from "../../../../../components/ui/InputFieldA";
import { useDispatch, useSelector } from "react-redux";
import { debounce, formatDate, formatTime } from "../../../../../utils/helper";
import { useState, useEffect, useRef } from "react";
import Icons from "../../../../../assets/js/Icons";
import { useParams } from "react-router-dom";

import {
  Avatar, Box, Button, Chip, Collapse, Grid2 as Grid,
  IconButton, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography
} from "@mui/material";

function SpecialistAppointments() {
  const dispatch = useDispatch();
  const { userId } = useParams();
  const searchRef = useRef("");
  const statusRef = useRef("");
  const entriesRef = useRef("");
  const startDateRef = useRef("");
  const endDateRef = useRef("");
  const { isActive, initiateAppointmentChat } = useChatInitiater();

  const [data, setData] = useState(null);
  const { loadings } = useSelector((state) => state.otherSlice);
console.log(data,"data")
  const handleRetrieveAppointments = (filters) => {
    dispatch(
      retrieveSpecialistAppointments({
        userId,
        search: searchRef?.current?.value || null,
        limit: entriesRef?.current?.value || null,
        currentPage: filters?.currentPage || null,
        status: statusRef?.current?.value?.value || null,
        startDate: startDateRef?.current?.value || null,
        endDate: endDateRef?.current?.value || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch(() => { });
  };

  const handleSearch = debounce(() => {
    handleRetrieveAppointments();
  }, 1000);

  useEffect(() => {
    if (userId)
      handleRetrieveAppointments();
    // eslint-disable-next-line
  }, [userId]);
  const statusConfig = {
    pending: { label: "Pending", bg: "#fff3e0", color: "#e65100" },
    confirmed: { label: "Confirmed", bg: "#e8f5e8", color: "#2e7d32" },
    completed: { label: "Completed", bg: "#e8f5e9", color: "#2e7d32" },
    rejected: { label: "Rejected", bg: "#ffebee", color: "#c62828" },
    cancelled: { label: "Cancelled", bg: "#f5f5f5", color: "#616161" },
    late_cancelled: { label: "Late Cancelled", bg: "#f5f5f5", color: "#616161" },
    expired: { label: "Expired", bg: "#ffebee", color: "#c62828" },
    no_show_specialist: { label: "No-Show (Specialist)", bg: "#fff3e0", color: "#f57c00" },
    no_show_member: { label: "No-Show (Member)", bg: "#fff3e0", color: "#f57c00" },
  };
  return (
    <Box
      sx={{
        p: 2,
        mt: 2,
        width: "100%",
        bgcolor: "white",
        overflow: "hidden",
        borderRadius: "12px",
        border: "1px solid #00000012",
      }}
    >
      <Grid
        container
        spacing={1}
        className="filters-grid"
        justifyContent="space-between"
      >
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            placeholder={"Search..."}
            label="Search by name or email"
            ref={searchRef}
            onChangeFun={handleSearch}
          />
        </Grid>

        {/* Date Range */}
        <Grid
          container
          direction="row"
          spacing={2}
          size={{ xs: 12, sm: 6, lg: "auto" }}
        >
          <Grid>
            <InputFieldA
              label="Start Date"
              type="date"
              inputRef={startDateRef}
            />
          </Grid>

          <Grid>
            <InputFieldA label="End Date" type="date" inputRef={endDateRef} />
          </Grid>

          <Grid>
            <Button
              variant="contained"
              sx={{ marginTop: "22px", padding: "10px 18px" }}
              onClick={handleRetrieveAppointments}
            >
              Apply
            </Button>
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAppointments();
              }, 0);
            }}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={statusRef}
            label="Appointment Status"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="All"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAppointments();
              }, 0);
            }}
            options={[
              { name: "Confirmed", value: "confirmed" },
              { name: "Pending", value: "pending" },
              { name: "Completed", value: "completed" },
              { name: "Cancelled", value: "cancelled" },
              { name: "Rejected", value: "rejected" },
              { name: "Late Cancelled", value: "late_cancelled" },
              { name: "No-Show (Member)", value: "no_show_member" },
              { name: "No-Show (Specialist)", value: "no_show_specialist" },
            ]}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} mt={2}>
        <Grid size={{ xs: 12, lg: "grow" }}>
          <Box className="content-listing">
            <TableContainer className="adminTable1">
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      "Member",
                      "Email",
                      "Status",
                      "Appointment Date",
                      "Time", "Actions"
                    ]?.map((cell, i) => (
                      <TableCell key={i} align="left">
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loadings?.retrieveAll ? (
                    <TableSkell colLength={6} />
                  ) : (
                    data?.records?.map((appointment, i) => (
                      <TableRow
                        key={i}
                        tabIndex={-1}
                        role="checkbox"
                        sx={{
                          td: {
                            borderBottomWidth:
                              i === data?.records?.length - 1
                                ? "0"
                                : "1px",
                          },
                        }}
                      >
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          <Box
                            gap={1}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Avatar src={appointment?.memberInfo?.image} />
                            <Typography>
                              {" "}
                              {appointment?.memberInfo?.name}{" "}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          {appointment?.memberInfo?.email || "N/A"}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={statusConfig[appointment?.appointmentStatus]?.label}
                            size="small"
                            sx={{
                              fontSize: "12.5px",
                              borderRadius: "20px",
                              backgroundColor:
                                statusConfig[appointment?.appointmentStatus]?.bg,
                              "& .MuiChip-label": {
                                color: `${statusConfig[appointment?.appointmentStatus]?.color
                                  } !important`,
                              },
                            }}
                          />{" "}
                        </TableCell>
                        <TableCell>
                          {formatDate(appointment?.startTime)}
                        </TableCell>
                        <TableCell>

                          {formatTime(appointment?.startTime) +
                            "-" + formatTime(appointment?.endTime)}
                        </TableCell>
                        <TableCell>
                          {appointment?.hasChat && (
                            <IconButton
                              size="small"
                              title="Accept"
                              color="primary"
                              sx={{ p: 0.25, fontSize: 20, mr: 0.5 }}
                              onClick={() => {
                                initiateAppointmentChat({
                                  sender: userId,
                                  appointmentId: appointment?._id,
                                  receiver: appointment?.memberInfo?._id,
                                })
                              }}
                            >
                              <Icons.ChatStrokeRounded />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}

                  {!data?.records?.length && !loadings?.retrieveAll && (
                    <TableRow sx={{ td: { borderBottom: "none" } }}>
                      <TableCell colSpan={6}>
                        <Typography variant="noRecords">
                          No appointments found!
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              pagination={data?.pagination}
              length={data?.records?.length}
              loading={loadings?.retrieveAll}
              cb={handleRetrieveAppointments}
              limit={entriesRef?.current?.value || 10}
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, lg: "auto" }}>
          <Collapse
            orientation="horizontal"
            in={isActive}
            timeout={300}
            unmountOnExit
          >
            <Messages />
          </Collapse>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SpecialistAppointments;
